"use client"

import { useLocation, useNavigate } from 'react-router-dom'
import { PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'
import { PageHeaderLeading } from '@/components/navigation/page-header-leading'
import { EvaluationAnalysisView } from '@/components/evaluation/evaluation-analysis-view'
import {
  buildEvaluationAnalysisBackPath,
  evaluationAnalysisBackLabel,
  type EvaluationAnalysisContext,
} from '@/lib/evaluation-analysis-paths'
import { getHrefWithThreadPreservation } from '@/utils/thread-navigation'

export type EvaluationAnalysisLocationState = {
  label?: string
  profileId?: string
  backPath?: string
  backLabel?: string
}

export type EvaluationAnalysisPageProps = {
  evaluationId: string
  context: EvaluationAnalysisContext
}

export function EvaluationAnalysisPage({
  evaluationId,
  context,
}: EvaluationAnalysisPageProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const state = (location.state as EvaluationAnalysisLocationState | null) ?? {}
  const subjectLabel = state.label
  const backPath = state.backPath ?? buildEvaluationAnalysisBackPath(context)
  const backLabel = state.backLabel ?? evaluationAnalysisBackLabel(context)

  const handleBack = () => {
    navigate(getHrefWithThreadPreservation(backPath))
  }

  return (
    <PageContainer>
      <PageHeaderLeading back={{ label: backLabel, onClick: handleBack }} />
        <PageHeader title="Match analysis" description={subjectLabel || 'Evaluation detail'} />
        <EvaluationAnalysisView evaluationId={evaluationId} subjectLabel={subjectLabel} />
      </PageContainer>
  )
}
